import { render, staticRenderFns } from "./EventApplications.vue?vue&type=template&id=0c2988c2"
import script from "./EventApplications.vue?vue&type=script&lang=js"
export * from "./EventApplications.vue?vue&type=script&lang=js"
import style0 from "./EventApplications.vue?vue&type=style&index=0&id=0c2988c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports